import Vue from 'vue'
import app from './app.vue'
import '@sdtj/index'
import './util/performance'
import { InfiniteScroll,Spinner } from 'mint-ui';
// import vConsole from './plug/vconsole.js'
import '../stylesheet/iconfont/iconfont.css'
import '../stylesheet/global.less'
import '../stylesheet/reset.less'
import 'mint-ui/lib/style.css'
import 'nprogress/nprogress.css'
import containerMain from './components/container-main.vue';
import {Containers} from '@roots/pLibrary/index.js'
//setup router
import router from './router'
//setup vuex
import store from './store'
import Install from '../js/lib/vueInstall'

import './filters/index'


// set up initialization
import './util/init'
import './directives'
// import './util/amap'
import keepAliveMixin from './mixins/common/keep-alive'
import scrollkeepAliveMixin from './mixins/common/scroll-keep-alive'
import {brand_logo,brand_title,default_seat,consumption_const,element_const,purchase_const,balance_const,amount_const} from '@app/js/util/common.js'
Vue.prototype.GLOBAL_logo = brand_logo
Vue.prototype.GLOBAL_title = brand_title
Vue.prototype.GLOBAL_default_seat = default_seat
Vue.prototype.GLOBAL_consumption_const = consumption_const
Vue.prototype.element_constelement_const = element_const
Vue.prototype.GLOBAL_element_const = element_const
Vue.prototype.GLOBAL_purchase_const = purchase_const
Vue.prototype.GLOBAL_balance_const = balance_const
Vue.prototype.GLOBAL_amount_const = amount_const
Vue.use(InfiniteScroll);
// mpSdtj.init()
// 使用自定义vue插件
Vue.use(Install)
Vue.mixin(keepAliveMixin)
Vue.mixin(scrollkeepAliveMixin)
Vue.component('containerMain', containerMain);
Vue.component('Containers', Containers);
Vue.component(Spinner.name, Spinner);
// Vue.use(vConsole)
Vue.config.ignoredElements = [
  'wx-open-launch-app',
  'wx-open-launch-weapp'
]
new Vue({
  router,
  store,
  render: h => h(app)
}).$mount('#main')

